import { computed, Injectable, signal } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MenuAction } from './list-management.types';

/**
 * ContextMenuManager gestisce menu contestuali con Signals
 */
@Injectable({ providedIn: 'root' })
export class ContextMenuManager<T> {
  private readonly _currentRow = signal<T | null>(null);
  private readonly _menuItems = signal<MenuItem[]>([]);
  private readonly _isOpen = signal(false);

  readonly currentRow$ = computed(() => this._currentRow());
  readonly menuItems$ = computed(() => this._menuItems());
  readonly isOpen$ = computed(() => this._isOpen());
  readonly hasItems$ = computed(() => this._menuItems().length > 0);

  setContextMenu(row: T, actions: MenuAction[]): void {
    this._currentRow.set(row);

    const menuItems: MenuItem[] = actions.map((action) => ({
      label: action.label,
      icon: action.icon,
      command: action.command,
      visible: action.visible !== false
    }));

    this._menuItems.set(menuItems);
    this._isOpen.set(true);
  }

  clearContextMenu(): void {
    this._currentRow.set(null);
    this._menuItems.set([]);
    this._isOpen.set(false);
  }

  toggleMenu(show: boolean): void {
    this._isOpen.set(show);
  }

  getCurrentRow(): T | null {
    return this._currentRow();
  }

  getMenuItems(): MenuItem[] {
    return this._menuItems();
  }
}
